module.exports = ".footer {\n  width: 100%;\n  bottom: 2.6%;\n  left: 0px;\n  right: 0px; }\n"